import { RSAA } from "redux-api-middleware";
import { getDefaultHeaders, getSettings } from "../Settings";
import { Direction, ITravelSegment, IVoucher } from "../Models";
import { ITableBooking } from "./Model";

export type ActionType = "clearBooking" | "setCancelModalVisible" |
"findBookingStarted" | "findBookingComplete" | "findBookingFailed" |
"loadPassengerTypesStarted" | "loadPassengerTypesComplete" | "loadPassengerTypesFailed" |
"loadOptionsStarted" | "loadOptionsComplete" | "loadOptionsFailed" |
"loadAvailableTimesForSegmentStarted" | "loadAvailableTimesForSegmentComplete" | "loadAvailableTimesForSegmentFailed" |
"bookTableForMealStarted" | "bookTableForMealComplete" | "bookTableForMealFailed" |
"updateOptionsStarted" | "updateOptionsComplete" | "updateOptionsFailed" |
"addTableBooking" |
"cancelTableBookingStarted" | "cancelTableBookingComplete" | "cancelTableBookingFailed" |
"startPaymentStarted" | "startPaymentComplete" | "startPaymentFailed" | "abortPayment" |
"cancelBookingStarted" | "cancelBookingComplete" | "cancelBookingFailed" |
"resendTicketsStarted" | "resendTicketsComplete" | "resendTicketsFailed" |
"revertChangesStarted" | "revertChangesComplete" | "revertChangesFailed";


export const clearBooking = () => ({ type: "clearBooking" as ActionType });
// export const showApp = (bookingNumber: string, email: string, mode?: string) => ({ type: "showApp" as ActionType, bookingNumber, email, mode });

export const findBooking = (bookingNumber: string, email: string, mode?: string) => {
	const payload = { bookingNumber, email, mode };

	return {
		type: "findBooking",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/booking/manage/find`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ type: "findBookingStarted", meta: payload },
				{ type: "findBookingComplete" },
				{ type: "findBookingFailed" }
			]
		}
	};
};

export const loadPassengerTypes = () => {

	return {
		type: "loadPassengerTypes",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/fare/passengertypes`,
			headers: getDefaultHeaders(),
			method: "GET",
			types: [
				{ type: "loadPassengerTypesStarted" },
				{ type: "loadPassengerTypesComplete" },
				{ type: "loadPassengerTypesFailed" }
			]
		}
	};
};

export const startPayment = (bookingNumber: string, paymentMethod: string, vouchers?: IVoucher[], discountCodes?: IVoucher[]) => {
	const payload = { bookingNumber, paymentMethod, vouchers, discountCodes };

	return {
		type: "startPayment",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/booking/manage/pay`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ type: "startPaymentStarted" },
				{ type: "startPaymentComplete" },
				{ type: "startPaymentFailed" }
			]
		}
	};
};
export const abortPayment = () => ({ type: "abortPayment"});

export const cancelBooking = (bookingNumber: string, direction?: string) => {

	const payload = { direction };

	return {
		type: "cancelBooking",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/booking/manage/${bookingNumber}/cancel`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ type: "cancelBookingStarted", meta: { bookingNumber, direction } },
				{ type: "cancelBookingComplete", meta: { bookingNumber, direction } },
				{ type: "cancelBookingFailed", meta: { bookingNumber, direction } }
			]
		}
	};
};

export const setCancelModalVisibility = (visible: boolean) => ({ type: "setCancelModalVisible", visible });

export const loadOptions = (bookingNumber: string) => {

	return {
		type: "loadOptions",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/booking/manage/${bookingNumber}/options`,
			headers: getDefaultHeaders(),
			method: "GET",
			types: [
				{ type: "loadOptionsStarted" },
				{ type: "loadOptionsComplete" },
				{ type: "loadOptionsFailed" }
			]
		}
	};
};

interface IChangedOption {
    segmentId: string;
    tariffCode: string;
    count: number;
    price: number;
};
export const updateOptions = (bookingNumber: string, changedOptions: IChangedOption[]) => {
	const payload = { updates: changedOptions };

	return {
		type: "updateOptions",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/booking/manage/${bookingNumber}/options`,
			headers: getDefaultHeaders(),
			method: "PATCH",
			body: JSON.stringify(payload),
			types: [
				{ type: "updateOptionsStarted" },
				{ type: "updateOptionsComplete" },
				{ type: "updateOptionsFailed" }
			]
		}
	};
};

export const updateOptionsOnTableBooking = (bookingNumber: string, segmentId: string, serviceName: string, options: { code: string, count: number }[]) => {
	const payload = { options, segmentId, serviceName };

	return {
		type: "updateOptionsOnTableBooking",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/tablebooking/booking/${bookingNumber}/updateoptions`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ type: "updateOptionsOnTableBookingStarted" },
				{ type: "updateOptionsOnTableBookingComplete" },
				{ type: "updateOptionsOnTableBookingFailed" }
			]
		}
	};
};

export const resendTickets = (bookingNumber: string) => {

	return {
		type: "resendTickets",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/booking/manage/${bookingNumber}/resendtickets`,
			headers: getDefaultHeaders(),
			method: "POST",
			types: [
				{ type: "resendTicketsStarted" },
				{ type: "resendTicketsComplete" },
				{ type: "resendTicketsFailed" }
			]
		}
	};
};

export const revertChanges = (bookingNumber: string) => {

	return {
		type: "revertChanges",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/booking/manage/${bookingNumber}/revertchanges`,
			headers: getDefaultHeaders(),
			method: "POST",
			types: [
				{ type: "revertChangesStarted" },
				{ type: "revertChangesComplete" },
				{ type: "revertChangesFailed" }
			]
		}
	};
};

export const addTableBooking = (tableBooking: ITableBooking) => ({ type: "addTableBooking", tableBooking });

export const cancelTableBooking = (bookingNumber: string, tableBookingId: number) => {
	const meta = { bookingNumber, tableBookingId };

	return {
		type: "cancelTableBooking",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/tablebooking/booking/${bookingNumber}/${tableBookingId}`,
			headers: getDefaultHeaders(),
			method: "DELETE",
			types: [
				{ meta, type: "cancelTableBookingStarted" },
				{ meta, type: "cancelTableBookingComplete" },
				{ meta, type: "cancelTableBookingFailed" }
			]
		}
	};
};

export const loadAvailableTimesForSegment = (bookingNumber: string, segment: ITravelSegment, persons: number, optionCode: string, slotStartTime: string, slotEndTime: string, slotOffsetDays: number) => {


	const payload = {
		departureTime: segment.departure,
		arrivalTime: segment.arrival,
		serviceName: segment.serviceName,
		slotStartTime,
		slotEndTime,
		slotOffsetDays,
		persons,
		productCode: optionCode
	};

	const meta = {
		bookingNumber,
		segmentId: segment.segmentId,
		optionCode
	}

	return {
		type: "loadAvailableTimesForSegment",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/tablebooking/availabletimes`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ meta, type: "loadAvailableTimesForSegmentStarted" },
				{ meta, type: "loadAvailableTimesForSegmentComplete" },
				{ meta, type: "loadAvailableTimesForSegmentFailed" }
			]
		}
	};

};

export const bookTableForMeal = (bookingNumber: string, direction: Direction, segmentId: string, serviceName: string, persons: number, time: string, date: string, slotName: string, temporary: boolean, currentBooking?: ITableBooking, options?: {code: string, count: number}[]) => {

	const meta = { bookingNumber, currentBookingId: currentBooking?.bookingId, temporary };

	const payload = {
		direction,
		segmentId,
		serviceName,
		persons,
		time,
		date,
		slotName,
		doNotResendTickets: true,
		temporary: true,
		options

	};

	const endpoint = currentBooking ? `${getSettings().apiUrl}/tablebooking/booking/${bookingNumber}/rebooktable/${currentBooking.bookingId}` :  `${getSettings().apiUrl}/tablebooking/booking/${bookingNumber}/booktable`;

	return {
		type: "bookTableForMeal",
		[RSAA]: {
			endpoint,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ meta, type: "bookTableForMealStarted" },
				{ meta, type: "bookTableForMealComplete" },
				{ meta, type: "bookTableForMealFailed" }
			]
		}
	};
}